import { FC, ReactNode } from 'react';
import classNames from 'classnames';

import styles from './modality-card.module.scss';

export enum CardType {
  primary = 'primary',
  surface = 'surface',
  primary200 = 'primary200',
  plain = 'plain',
}

type Props = {
  title?: string;
  info?: string;
  className?: string;
  shouldGrow?: boolean;
  type?: keyof typeof CardType;
  children?: ReactNode;
};

const ModalityCard: FC<Props> = ({
  title,
  info,
  children,
  className,
  shouldGrow,
  type = CardType.surface,
}: Props) => {
  return (
    <div
      data-testid='modality-card'
      className={classNames(
        styles.card,
        styles[`card-${type}`],
        shouldGrow && styles[`card-grow`],
        className,
      )}
    >
      {title || info ? (
        <div className={styles['card-info']}>
          {title && <h3>{title}</h3>}
          {info && <p>{info}</p>}
        </div>
      ) : null}

      {children}
    </div>
  );
};

export default ModalityCard;
